module.exports = __webpack_public_path__ + "img/b3c6ac4.jpg";